import groq from 'groq';
import {
  externalLink,
  internalLink,
  internalLinkReference,
  ssuLink,
} from '@pkg/sanity-utils/linkQueries';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';
import { TOP_LEVEL_LINK_TYPE } from '../types/mainNav';

/**
 * Field projection for a navigation.headers document (no `mainNav->` wrapper).
 */
export const mainNavFields = groq`
  "topLevelMenuItems": navigationMenu.topLevelMenuItems[] {
    _type,
    title,
    _type == '${TOP_LEVEL_LINK_TYPE}' => {
      linkType,
      "internalAnchor": internalAnchor.internal,
      "reference": internal->{ ${internalLinkReference} },
      external,
      ssu,
      newWindow,
    },
    "submenuLists": submenuLists[] {
      submenuListTitle,
      "submenuListItems": submenuListItems[] {
        ${externalLink},
        ${internalLink},
        ${ssuLink},
      }
    },
    "additionalInfo": additionalInfo[] {
      ${portableTextWithReferences}
    }
  },
  "menuActions": headerActions[] {
    _type,
    _key,
    "internalLink": internalLink { ${internalLink} },
    "externalLink": externalLink { ${externalLink} },
    "ssuLink": ssuLink { ${ssuLink} },
    appstoreLink,
    button,
  },
  "mobileHeaderActionKey": mobileHeaderActionKey,
`;

/**
 * Theme field projection: dereference `mainNav` with nav fields.
 * Used by www site-manifest (theme already audience-scoped by the parent query).
 */
export const mainNav = groq`
mainNav->{
  ${mainNavFields}
}
`;
